import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MessageService } from 'primeng/components/common/messageservice';

import { Perfis } from '../../../models/perfis';
import { AuthService } from '../../admin/auth.service';

import { WebPage } from '../../shared/web-page';

import { Util } from '../../shared/util';
import { Router } from '@angular/router';
import { PesquisaHistoricoEmail } from '../../../models/historico-geral.model';
import { HistoricoGeralService } from '../../../services/historico-geral.service';
import { EmailAssuntoConteudo, EmailLog } from '../../../models/emailLog.model';


@Component({ templateUrl: './historico-email.component.html',styleUrls: ['./historico-email.component.scss'] })
export class HistoricoEmailComponent extends WebPage implements OnInit {
  emails: Array<EmailLog> = [];
  form: FormGroup = {} as FormGroup;
  perfis: any = {};
  emailModal: EmailLog = null;
  isLoading: boolean =false;

  todosStatus = [
    {id: true, nome: "Entregue"},
    {id: false, nome: "Falha no Envio"}]
  usuario: any = {};
  hoje = new Date().toISOString().split('T')[0];

  constructor(
    messageService: MessageService,
    private authService: AuthService,
    private fb: FormBuilder,
    private _router: Router,
    private _historico: HistoricoGeralService
  ) {
    super(messageService);
  }

  ngOnInit() {
    this.isLoading = true;
    this.usuario = this.authService.informacoesUsuario();
    this.perfis = Perfis;
    this.criarForm();
    this.pesquisar();
  }

  private criarForm() {
    this.form = this.fb.group({
      remetente: [''],
      destinatario: [''],
      cnpj: [''],
      razaoSocial: [''],
      dataEnvio: [''],
      status: [''],
    });
  }

  

  

  pesquisar() {
    this.isLoading = true;
    this.messageService.clear();
    const pesquisa = this.montarObjetoPesquisa();

    this._historico.getHistoricoEmail(pesquisa).subscribe((v)=>{
      this.emails= v.map((v) => {
        v.historicoGeral.dados = JSON.parse(v.historicoGeral.dados) as EmailAssuntoConteudo;
        return v;
      }).sort((a,b)=> {
        if(a.dataCadastro > b.dataCadastro){
          return -1
        } else if(a.dataCadastro < b.dataCadastro){
          return 1;
        }
        return 0;
      });

      this.isLoading = false;
    },(error) => {
      this.isLoading = false;
      this.gerenciaErro(error)
    })
    
  }

  montarObjetoPesquisa(): PesquisaHistoricoEmail{
    function isEmptyReturnNull(value: any){
      if(value === null ||value === '') {
        return null;
      }
      return value;
    }

    const cnpj = isEmptyReturnNull(this.form.get('cnpj').value)

    const obj : PesquisaHistoricoEmail = {
      remetente: isEmptyReturnNull(this.form.get('remetente').value),
      destinatario: isEmptyReturnNull(this.form.get('destinatario').value),
      cnpj: cnpj !== null ? cnpj.replace(/\D/g, ''): null,
      razaoSocial: isEmptyReturnNull(this.form.get('razaoSocial').value),
      dataEnvio: isEmptyReturnNull(this.form.get('dataEnvio').value),
      status: isEmptyReturnNull(this.form.get('status').value),
    }
    return obj
  }

  abrirModalDetalhes(emailSelecionado : any) {
    this.emailModal = emailSelecionado;
  }


  get remetente() {
    return this.form.controls.remetente;
  }
  get destinatario() {
    return this.form.controls.destinatario;
  }
  get cnpj() {
    return this.form.controls.cnpj;
  }
  get razaoSocial() {
    return this.form.controls.razaoSocial;
  }
  get dataEnvio() {
    return this.form.controls.dataEnvio;
  }
  get status() {
    return this.form.controls.status;
  }

  voltar() {
    this._router.navigate(['/gerenciar-vagas']);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/proposta/historicoEmail/historico-email.component.ts